<template>
	<div class="global-input-secondary global-input-secondary--rounded" :class="{ 'global-secondary--required': required }">
		<v-text-field ref="inputRef" flat v-bind="$attrs" density="comfortable" variant="solo">
			<template v-if="appendInner" #append-inner>
				<GlobalIcon :name="appendInner" :height="20"></GlobalIcon>
			</template>
			<template v-if="prependInner" #prepend-inner> <GlobalIcon :name="prependInner" :height="18" /> </template>
		</v-text-field>
	</div>
</template>

<script setup lang="ts">
interface InputProps {
	productExist?: number | string
	appendInner?: string
	required?: boolean
	prependInner?: string
}

const inputRef = ref()

watch(
	() => inputRef.value,
	(newValue) => {
		if (inputRef.value) emit('update:ref', newValue)
	},
	{ deep: true },
)

defineProps<InputProps>()

const emit = defineEmits<{
	(e: 'update:ref', value: Ref): void
}>()
</script>

<style lang="scss">
@import './Secondary.scss';
</style>
